import styled from "styled-components";

interface IContainer {
  height?: string;
  width?: string;
}
export const Container = styled.div<IContainer>`
  .p-multiselect {
    align-items: center;
    border-radius: 0.8rem;
    border: none;
    box-shadow: 0px 5px 20px rgba(231, 231, 234, 0.62);
    display: flex;
    height: ${(props) => props.height};
    padding: 0.8rem;
    width: ${(props) => props.width};
  }
  .p-multiselect.p-multiselect-chip .p-multiselect-token {
    background: rgba(23, 21, 120, 0.1);
    color: ${(props) => props.theme.colors.blackTextBody};
    font-family: ${(props) => props.theme.fontFamilies.primaryFont};
    font-size: 1.4rem;
    padding: 0.8rem;
  }
`;
